<div class="flex align-items-center pl-5 py-2" *ngIf="headerData === null">
  <p-skeleton shape="circle" size="4rem" styleClass="mr-5" />
  <p-skeleton width="12rem" styleClass="mb-2" />
</div>

<div class="grid sm:flex-nowrap justify-content-between mx-3" data-cy="donation-header" *ngIf="headerData != null">
  <!-- hiding on mobile to save space -->
  <div class="col hidden sm:flex align-items-center">
    <i class="fa-sharp fa-regular fa-money-check-dollar content-type-icon"></i>
  </div>

  <div class="col flex align-items-center" style="flex-grow: 6;" data-cy="donation-info">
    <div>
      <p class="text-xl md:text-2xl">
        <span class="inline-block mr-2 font-bold red-60">
          {{ headerData?.donationAmount !== 0 ? headerData?.donationAmount : 'N/A' }}
        </span>
        <span class="inline-block mr-2 font-light">
          {{ headerData?.donationDate | date:'MM/dd/yyyy' }}
        </span>
        <span class="inline-block font-bold">{{ headerData?.donationID }}</span>
      </p>
      <p class="mb-1">
        <span class="inline-block mr-2 font-bold">
          {{ headerData?.donorPrefix ? headerData.donorPrefix + '.' : '' }}
          {{ headerData?.donorFirstName }} {{ headerData?.donorLastName }}
          {{ headerData?.donorSuffix ? headerData.donorSuffix + '.' : '' }}
        </span>
        <a
          href="javascript:void(0)"
          (click)="donorIdClick.emit(headerData?.donorID)">
          ({{ headerData?.donorID }})
        </a>
      </p>
      <p class="mb-0 font-bold">
        {{ headerData?.campaignName }} - {{ headerData?.fundCode }}
      </p>
    </div>
  </div>
  
  <div class="col-12 sm:col flex align-items-center justify-content-center sm:justify-content-end">
    <p-button
      *ngIf="!['Fundraisers', 'Donation Letters', 'Notes', 'Donation Flags'].includes(activeTab)"
      styleClass="p-button-icon-teal-light button-card-edit mx-1"
      icon="fa-sharp fa-light fa-pencil"
      [rounded]="true"
      (onClick)="onEditDonation()"
      title="Edit Donation"
      data-cy="edit-donation-button"
      [disabled]="isReadOnlyMode"
    ></p-button>
    <p-button
      styleClass="p-button-icon-red-light button-card-delete mx-1"
      icon="fa-sharp fa-light fa-trash-can"
      [rounded]="true"
      title="Delete Donation"
      data-cy="delete-donation-button"
      (onClick)="onDeleteDonation()"
      [disabled]="isReadOnlyMode"
    ></p-button>
  </div>
</div>
